import { useEffect, useState, createElement } from 'react';
import './carousel.scss';
const Carousel = ({ images = [], interval = 3000, }) => {
    if (images.length === 0) {
        return createElement("div", null);
    }
    if (images.length === 1) {
        return (createElement("div", { className: "carousel" },
            createElement("img", { src: images[0], alt: "Single slide", className: "carousel-image" })));
    }
    const extendedImages = [images[images.length - 1], ...images, images[0]];
    const [currentIndex, setCurrentIndex] = useState(1);
    const goToNext = () => {
        setCurrentIndex((prevIndex) => prevIndex + 1);
    };
    useEffect(() => {
        const timer = setInterval(() => {
            goToNext();
        }, interval);
        return () => clearInterval(timer);
    }, [interval]);
    useEffect(() => {
        if (currentIndex === extendedImages.length - 1) {
            setTimeout(() => {
                setCurrentIndex(1);
            }, 1000);
        }
    }, [currentIndex]);
    const displayIndex = currentIndex > images.length ? currentIndex - images.length : currentIndex;
    return (createElement("div", { className: "carousel" },
        createElement("div", { className: "carousel-track", style: {
                transform: `translateX(-${currentIndex * 100}%)`,
                transition: currentIndex === 1 ? 'none' : 'transform 1s ease-in-out',
            } }, extendedImages.map((image, index) => (createElement("img", { key: index, src: image, alt: `Slide ${index}`, className: "carousel-image" })))),
        createElement("div", { className: "carousel-counter" },
            createElement("span", null, displayIndex),
            createElement("span", null, "/"),
            createElement("span", null, images.length))));
};
export default Carousel;
